import { render, staticRenderFns } from "./AddressCreate.vue?vue&type=template&id=6638cf84&scoped=true&"
import script from "./AddressCreate.vue?vue&type=script&lang=js&"
export * from "./AddressCreate.vue?vue&type=script&lang=js&"
import style0 from "./AddressCreate.vue?vue&type=style&index=0&id=6638cf84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6638cf84",
  null
  
)

export default component.exports